/// <summary>
/// 统计上传逻辑
/// </summary>

import KitAPI from "../KitAPI";
import KitLog from "../KitLog";
import {CacheManager} from "./CacheManager";
import {DisasterTimeHelper} from "./DisasterTimeHelper";
import {EData} from "./EData";
import {KitTrack} from "./KitTrack";
import {UploadRequst} from "@/Fwk/Kit/Track/UploadRequst";
import {JObject} from "@/Fwk/Kit/JObject";

/// <author>xiexingwu</author>
export class UploadManger {
    static _waitTime: number = 0;
    static lastUpLoadData: EData[] = [];

    static Start() {
        KitTrack._task.AddTask(5, ()=>{this.Loop()}, "UploadManger", -1);
    }

    static Loop() {
        //收集缓存摘要信息
        const [type, count] = CacheManager.Summary();
        if (count == 0) {
            this._waitTime += 5;
            if (KitLog.IsLog) KitTrack.Log(`[轮询]本地无数据,不上传,等待时间+5s,共${this._waitTime}秒`);
            return;
        }

        const delayTime = DisasterTimeHelper.CalcDelayTime();
        if (delayTime > 0 && this._waitTime <= delayTime) {
            if (KitLog.IsLog) KitTrack.Log(`[轮询]等待时间{this._waitTime}小于容灾延缓时间${delayTime},不上传,等待时间+5s,共${this._waitTime + 5}秒`);
            this._waitTime += 5;
            return;
        }

        if (type == KitTrack.SRC_TYPE_NOW) {
            if (KitLog.IsLog) KitTrack.Log("[轮询]本地还有实时协议数据,满足上传条件");
            this.DoUpLoadData();
        } else if (count >= 40) {
            if (KitLog.IsLog) KitTrack.Log("[轮询]本地堆积数据超过40条,满足上传条件");
            this.DoUpLoadData();
        } else if (this._waitTime >= 15 + delayTime) {
            if (KitLog.IsLog) KitTrack.Log("[轮询]本地存在任意统计数据,等待到达15s,满足上传条件");
            this.DoUpLoadData();
        } else if (type == KitTrack.SRC_TYPE_COM && this._waitTime >= 15 + delayTime) {
            if (KitLog.IsLog) KitTrack.Log("[轮询]本地存在普通统计数据,等待到达15s,满足上传条件");
            this.DoUpLoadData();
        } else {
            //都不满足上传条件
            this._waitTime += 5;
            if (KitLog.IsLog) KitTrack.Log(`[轮询]等待时间+5s,共${this._waitTime}秒`);
        }
    }

    private static DoUpLoadData() {
        const list = CacheManager.GetUploadDataList();
        if (list.length > 0) {

            let array: JObject[] = [];
            for (let eData of list) {
                const json = eData.GetUpLoadJsonData();
                // const json = eData.GetUpLoadJsonData().jObject;
                if (json && json.Count > 0) {
                    array.push(json.jObject)
                }
            }

            if (array.length > 0) {
                const isDo = UploadRequst.Upload(array, ()=>{this.onSuccess()}, (a)=>{this.onFail(a)});
                if (isDo) {
                    this.lastUpLoadData = list;
                }
            }
        }
    }

    public static onSuccess() {
        this._waitTime = 0;
        DisasterTimeHelper.Reset();
        CacheManager.Remove(this.lastUpLoadData);
        this.showLogV("打点数据删除成功");
    }

    public static onFail(failParam: string) {
        this._waitTime = 0;
        this.showLogE(`打点日志上传失败： ${failParam}`);
        DisasterTimeHelper.AddFailCount();
    }

    private static showLogV(msg: string) {
        KitTrack.Log(msg);
    }

    private static showLogE(msg: string) {
        KitTrack.LogW(msg);
    }


}
